<template>
  <div>
    <h5 class="info-text"> Please choose your contracts : </h5>
    <div class="row justify-content-center">
      <div class="col-lg-10">

        <div class="row">
          <div class="row col-12">
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.monizze.status"
                             icon="nc-icon nc-ruler-pencil"
                             title="Monizze">
              </icon-checkbox>
            </div>
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.monizze_ec.status"
                             icon="nc-icon nc-paper"
                             title="Eco-chèque monizze">
              </icon-checkbox>
            </div>
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.monizze_cc.status"
                             icon="nc-icon nc-bag-16"
                             title="Chèque cadeau monizze">
              </icon-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row col-12">
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.edenred.status"
                             icon="nc-icon nc-ruler-pencil"
                             title="Edenred">
              </icon-checkbox>
            </div>
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.edenred_ec.status"
                             icon="nc-icon nc-paper"
                             title="Eco-chèque edenred">
              </icon-checkbox>
            </div>
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.edenred_cc.status"
                             icon="nc-icon nc-bag-16"
                             title="Chèque cadeau edenred">
              </icon-checkbox>
            </div>
          </div>
        </div>
          <!--
        <div class="row">
          <div class="row col-sm-12">
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.sodexo.status"
                             icon="nc-icon nc-ruler-pencil"
                             title="Sodexo">
              </icon-checkbox>
            </div>
            <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
              <icon-checkbox v-model="model.sodexo_ec.status"
                             icon="nc-icon nc-paper"
                             title="Eco-chèque sodexo">
              </icon-checkbox>
            </div>
          </div>
        </div>
        -->


          <div class="row">
              <div class="row col-sm-12">
                  <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                      <icon-checkbox v-model="model.sodexoPluxee.status"
                                     icon="nc-icon nc-ruler-pencil"
                                     title="Sodexo - pluxee">
                      </icon-checkbox>
                  </div>
                  <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12">
                      <icon-checkbox v-model="model.sodexoPluxee_ec.status"
                                     icon="nc-icon nc-paper"
                                     title="Eco-chèque sodexo - pluxee">
                      </icon-checkbox>
                  </div>
              </div>
          </div>

      </div>
    </div>
  </div>
</template>
<script>
  import {IconCheckbox} from 'src/components/UIComponents'

  export default {
    components: {
      IconCheckbox
    },
    data() {
      return {
        model: {
          sodexoPluxee : { status : false, offName : 'MealSodexoPluxee', activities: []  },
            sodexoPluxee_ec : { status : false, offName : 'EcoSodexoPluxee', activities: []  },
            sodexo: { status : false, offName : 'MealSodexo', activities: []  },
          sodexo_ec: { status : false, offName : 'EcoSodexo', activities: []   },
          monizze: { status : false, offName : 'MealMonizze', activities: []   },
          monizze_ec: { status : false, offName : 'EcoMonizze', activities: []  },
          monizze_cc: { status : false, offName : 'GiftMonizze', activities: []  },
          edenred: { status : false, offName : 'MealEdenred', activities: []   },
          edenred_ec: { status : false, offName : 'EcoEdenred', activities: []  },
          edenred_cc: { status : false, offName : 'GiftEdenred', activities: []  },
          ems: { status : false, offName : 'ems', activities: [] },
        },
      }
    },
    methods: {
      validate() {
        if(!this.model.sodexoPluxee && !this.model.sodexoPluxee_ec && !this.model.sodexo && !this.model.sodexo_ec && !this.model.monizze && !this.model.monizze_cc && !this.model.monizze_ec && !this.model.edenred && !this.model.edenred_cc && !this.model.edenred_ec && !this.model.ems) {
          return Promise.resolve(false)
        } else {
          this.$emit('on-validated', true, {contracts : this.model })
          return Promise.resolve(true)
        }
      }
    }
  }
</script>
<style>
</style>
